var _class;
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import Component from '@glimmer/component';
import { assert } from '@ember/debug';
import { isChangeset } from 'ember-form-changeset-validations/utils/is-changeset';
import { dropTask, task } from 'ember-concurrency';
import { waitFor } from '@ember/test-waiters';
import { taskFor } from 'ember-concurrency-ts';
import { ImmerChangeset } from 'ember-form-changeset-validations/changeset/immer-changeset';
let ChangesetFormComponent = (_class = class ChangesetFormComponent extends Component {
  constructor(owner, args) {
    super(owner, args);
    assert('@changeset is required and must be an ImmerChangeset', isChangeset(args.changeset) && args.changeset instanceof ImmerChangeset);
    assert('@onSubmit is required', typeof args.onSubmit === 'function');
    assert('@validationFunction is required', typeof args.validationFunction === 'function');
  }
  *validateAndSubmit() {
    yield this.args.changeset.validate(this.args.validationFunction);
    if (this.args.changeset.isValid) {
      yield this.args.onSubmit(this.args.changeset);
    }
  }
  *submit(e) {
    e.preventDefault();
    const task = taskFor(this.validateAndSubmit);
    yield task.perform();
  }
}, (_applyDecoratedDescriptor(_class.prototype, "validateAndSubmit", [dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "validateAndSubmit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "submit", [task, waitFor], Object.getOwnPropertyDescriptor(_class.prototype, "submit"), _class.prototype)), _class);
export { ChangesetFormComponent as default };